module.exports = __webpack_public_path__ + "static/media/placeholder.62d2473f.png";